import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import React, { MouseEventHandler, useCallback } from 'react'
import { connect } from 'react-redux'
import { selectBusinessTravellerCurrentApprovalRequest } from 'businessTraveller/selectors/selectBusinessTravellerCurrentApprovalRequest'

interface Props {
  /**
   * The percentage the budget is exceeded by.
   */
  underPercentage: number
  onClick: MouseEventHandler<HTMLButtonElement>
  currentApprovalRequest?: App.BusinessTraveller.ApprovalRequest
  /**
   * Overrides the label. When 'budget', always show "Under budget by X%".
   * When 'approval' or undefined, show "Within approved range" when there is an approval, else "Under budget by X%".
   */
  labelVariant?: 'approval' | 'budget'
}

function PriceRowBusinessTravellerUnderBudget(props: Props) {
  const {
    underPercentage,
    onClick,
    currentApprovalRequest,
    labelVariant,
  } = props

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()

    onClick(event)
  }, [onClick])

  const useApprovalLabel = labelVariant === 'approval' || (labelVariant === undefined && !!currentApprovalRequest?.approverId)

  return <Clickable onClick={handleClick}>
    <StatusLabel variant="confirmation" endIcon={!!onClick && <LineInfoCircleIcon />}>
      {useApprovalLabel ? 'Within approved range' : `Under budget by ${underPercentage}%`}
    </StatusLabel>
  </Clickable>
}

const mapStateToProps = (state: App.State) => ({
  currentApprovalRequest: selectBusinessTravellerCurrentApprovalRequest(state),
})

export default connect(mapStateToProps)(PriceRowBusinessTravellerUnderBudget)
